import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/native';
import Error from './error-screen';
import illustrations from '../assets/illustrations';
import Text from '../text';
import Colors from '../colors';
import Spacer from '../spacer';
const TextContainer = styled.View`
  width: 100%
`;
export default function Maintenance(props) {
  return /*#__PURE__*/React.createElement(Error, {
    title: "We're making changes to improve our services",
    paddingBottom: 74,
    illustration: illustrations.Maintenance,
    centered: props.centered,
    titleColor: props.titleColor,
    labelColor: props.labelColor,
    backgroundColor: props.backgroundColor
  }, /*#__PURE__*/React.createElement(TextContainer, null, /*#__PURE__*/React.createElement(Text.BodyBase, {
    color: props.textColor,
    align: "center"
  }, "We apologize for any inconvenience caused and expect to be back online", ' ', props.maintenanceEndTime, "."), /*#__PURE__*/React.createElement(Spacer, {
    size: "f16",
    height: true
  }), /*#__PURE__*/React.createElement(Text.BodyBase, {
    color: props.textColor,
    align: "center"
  }, "Thank you for your patience and understanding!")));
}
Maintenance.defaultProps = {
  centered: true,
  titleColor: Colors.gray600,
  labelColor: Colors.gray100,
  backgroundColor: Colors.white,
  textColor: Colors.gray400,
  maintenanceEndTime: 'shortly'
};
Maintenance.propTypes = {
  centered: PropTypes.bool,
  titleColor: PropTypes.node,
  labelColor: PropTypes.node,
  backgroundColor: PropTypes.node,
  textColor: PropTypes.node,
  maintenanceEndTime: PropTypes.string
};
//# sourceMappingURL=maintenance.js.map